/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import http from './index';
import { GetActListParams, BannerHttpResponse, GetArticleParams, getStoryListParams, HttpResponse, IActTabProps, ICircleInfoProps, IClockTaskProps, IHotActProps, ISjqnwArticleProps, IStoryDescProps, ReturnDataType, SjqnwArticleProps, usTaskEroSituationPrams, usTaskEroSituationProps } from './type';

interface LoginParams {
  mobile: unknown
  valicode: unknown
  notPrompt: unknown
  regChannel:unknown
  bindType:unknown
}
interface authCodeParams {
  mobile: unknown
}
export class UserService {
  static async login(params: LoginParams): Promise<HttpResponse> {
    return http.post('/us/login/1.0/', {
      ...params
    });
  }
  static async getAuthCode(params: authCodeParams): Promise<HttpResponse> {
    return http.post('/us/authCode/1.0/', {
      ...params
    });
  }
  static async checkLoginOrRegister(params: authCodeParams): Promise<HttpResponse> {
    return http.post('/us/checkLoginOrRegister/1.0/', {
      ...params
    });
  }
}

// 发帖相关

interface postParams {
  scText: string // 帖子正文
  scType: unknown // 帖子所属类型
  scPicUrl: unknown
}
interface uploadParams {
  file: unknown //
}
// 跑步
interface runParams {
  scText: string // 帖子正文
  scType: unknown // 帖子所属类型
  scPicUrl: unknown
  subType: unknown
  runJson: unknown
}
// 读书
interface readParams {
  scText: string // 帖子正文
  scType: unknown // 帖子所属类型
  scPicUrl: unknown // 图片地址
  subType: unknown // 帖子二级类型
  mappingId: unknown // 书籍id
  extContent: unknown// 书籍相关信息
}
export class usNewPosting {
  // 普通发帖
  static async posting(params: postParams): Promise<HttpResponse> {
    return http.post('/us/usNewPosting/1.0/', {

      ...params
    });
  }
  // 跑步发帖
  static async postRun(params: runParams): Promise<HttpResponse> {
    return http.post('/us/usRunningExt/1.0/', {
      ...params
    });
  }

  // 读书发帖
  static async postRead(params: readParams): Promise<HttpResponse> {
    return http.post('/proxy/us/usReadExt/1.0', {
      ...params
    });
  }

  static async selCircleTopic(): Promise<HttpResponse> {
    return http.post('/us/selCircleTopic/1.0/', {});
  }
  static async upload(params: uploadParams): Promise<HttpResponse> {
    return http.post('/uploadFile', {});
  }
}
interface searchParams {
  type: number
  keyWords:string
  pageNum: number
  pageSize: number
}
interface bannerId {
  id:unknown
}

export class searchInfo {
  static async searchBook(params: searchParams): Promise<HttpResponse> {
    return http.post('/search/getSearchResultList/1.0/', {
      ...params
    });
  }
  static async searchBanner(): Promise<ReturnDataType<BannerHttpResponse>> {
    return http.post('/us/sjqnwBanner/1.0/', {});
  } static async clickBanner(params:bannerId): Promise<ReturnDataType<BannerHttpResponse>> {
    return http.post('/us/sjqnwClickBanner/1.0/', { ...params });
  }
}

export class ActivityFetch {
  static async getActList(params: GetActListParams): Promise<ReturnDataType<IClockTaskProps[]>> {
    return http.post('/mkt/selClockTaskByType/1.0/', {
      ...params
    });
  }
  static async getActTab(params: { type: string }): Promise<ReturnDataType<IActTabProps>> {
    return http.post('/mkt/selClockTaskTabInfos/1.0/', {
      ...params
    });
  }
  static async getActDetail(params: { taskId: string, newVersion: string }): Promise<ReturnDataType<IClockTaskProps>> {
    return http.post('/mkt/selClockTaskDetails/1.0/', {
      ...params
    });
  }
  static async getMoreAct(params: GetActListParams): Promise<ReturnDataType<IHotActProps[]>> {
    return http.post('/mkt/selUpwardActivityInfo/1.0/', {
      ...params
    });
  }
  static async enrollUpwardAct(params: { actId: string | number, learnId?: string, orderNo?: string }): Promise<ReturnDataType<any>> {
    return http.post('/mkt/enrollUpwardAct/1.0/', {
      ...params
    });
  }
  static async usTaskClockEnroll(params: { taskId: string | number }): Promise<ReturnDataType<boolean>> {
    return http.post('/us/usTaskClockEnroll/1.0/', {
      ...params
    });
  }
  static async usTaskEroSituation(params: Partial<usTaskEroSituationPrams>): Promise<ReturnDataType<usTaskEroSituationProps>> {
    return http.post('/mkt/usTaskEroSituation/1.0/', {
      ...params
    });
  }
  static async usTaskClockRanking(params: Partial<usTaskEroSituationPrams>): Promise<ReturnDataType<usTaskEroSituationProps>> {
    return http.post('/mkt/usTaskClockRanking/1.0/', {
      ...params
    });
  }
  static async selClockTaskRecords(params: { userId: string, taskId: string }): Promise<ReturnDataType<number>> {
    return http.post('/mkt/selClockTaskRecords/1.0/', {
      ...params
    });
  }
  static async selCircleDynamicInfos(params: { userId?: string, taskId: string }): Promise<ReturnDataType<ICircleInfoProps[]>> {
    return http.post('/us/selCircleDynamicInfos/1.0/ ', {
      ...params
    });
  }

  static async selCircleDynamicsDetail(params: { id: string }): Promise<ReturnDataType<ICircleInfoProps>> {
    return http.post('/us/selCircleDynamicsDetail/1.0/ ', {
      ...params
    });
  }
  static async getCommentInfo(params: {
    mappingId: string,
    mappingType: string,
    pageNum: number,
    pageSize: number
  }): Promise<ReturnDataType<ICircleInfoProps[]>> {
    return http.post('/mkt/getCommentInfo/1.0/ ', {
      ...params
    });
  }
  static async addNewComment(params: {
    ifLimit: number,
    content: string,
    headUrl: string,
    mappingId: string,
    commentType: string,
    // nickName: string,
    realName: string,
  }): Promise<ReturnDataType<ICircleInfoProps[]>> {
    return http.post('/mkt/addNewComment/1.0/', {
      ...params
    });
  }
  static async usPraise(params: {
    fabulousNum?: number,
    praiseType?: number,
    praiseId?: number | string,
    userName?: string
  }): Promise<ReturnDataType<any>> {
    return http.post('/us/usPraise/1.0/ ', {
      ...params
    });
  }
  static async usReadOrForward(params: {
    readNum?: number,
    heatType?: number,
    mappingId?: number | string,
    type?: string
  }): Promise<ReturnDataType<any>> {
    return http.post('/us/usReadOrForward/1.0/ ', {
      ...params
    });
  }
}

export class MessageFetch {
  static async getArticleList(params: GetArticleParams): Promise<ReturnDataType<ISjqnwArticleProps[]>> {
    return http.post('/us/sjqnwArticleList/1.0/', {
      ...params
    });
  }
  static async getArticleDetail(params: { sjqnwArticleType: string, id: string }): Promise<ReturnDataType<SjqnwArticleProps>> {
    return http.post('/us/sjqnwArticleDetails/1.0/', {
      ...params
    });
  }
  static async sjqnwArticleRecommend(params: {
    sjqnwArticleType: string
  }): Promise<ReturnDataType<ISjqnwArticleProps[]>> {
    return http.post('/us/sjqnwArticleRecommend/1.0/ ', {
      ...params
    });
  }
  static async sjqnwArticleBrowse(params: {
    id: string
  }): Promise<ReturnDataType<boolean>> {
    return http.post('/us/sjqnwArticleBrowse/1.0/ ', {
      ...params
    });
  }
}

export class StoryFetch {
  static async getStoryList(params: Partial<getStoryListParams>): Promise<ReturnDataType<IStoryDescProps[]>> {
    return http.post('/mkt/scholarshipStoryList/1.0/', {
      ...params
    });
  }
  static async getStoryDetail(params: { scholarshipId: string, authToken: string }): Promise<ReturnDataType<IStoryDescProps[]>> {
    return http.post('/mkt/selectBdScholarshipStoryInfoById/1.0/', {
      ...params
    });
  }
  static async updateFabulousNum(params: {
    fabulousNum: number,
    scholarshipId: string
  }): Promise<ReturnDataType<boolean>> {
    return http.post('/mkt/updateFabulousNum/1.0/ ', {
      ...params
    });
  }
  static async sjqnwArticleGiveLike(params: {
    id: string,
    likeType: number
  }): Promise<ReturnDataType<boolean>> {
    return http.post('/us/sjqnwArticleGiveLike/1.0/ ', {
      ...params
    });
  }
  static async updateReadNum(params: {
    scholarshipId: string
  }): Promise<ReturnDataType<boolean>> {
    return http.post('/mkt/updateReadNum/1.0/ ', {
      ...params
    });
  }
}

export class MineFetch {
  static async selCircleDynamics(params: {
    userId: string,
    version: string,
    pageNum: number,
    pageSize: number
  }): Promise<ReturnDataType<ICircleInfoProps[]>> {
    return http.post('/us/selCircleDynamics/1.0/ ', {
      ...params
    });
  }
  static async selRecCircleDynamics(params: {

  }): Promise<ReturnDataType<ICircleInfoProps[]>> {
    return http.post('/us/selCircleDynamicInfos/1.0/ ', {
      ...params
    });
  }

  static async getUserInfoById(params: {
    userId: string,

  }): Promise<ReturnDataType<any>> {
    return http.post('/us/getUserInfoById/1.0/ ', {
      ...params
    });
  }
}
